// 各种mutation类型

// 用户模块
export const LOGOUT = 'LOGOUT'
export const LOGIN = 'LOGIN'

// 设备模块
export const SETDEVARGSMSG = 'setDevArgsMsg'

// 侧边栏模块

export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'
export const SET_MENUS = 'SET_MENUS'
export const SET_REGIONS = 'SET_REGIONS'
export const CURRENT_MENUS = 'CURRENT_MENUS'




// WEBPACK FOOTER //
// ./src/store/mutation.types.js